import {GetFieldDecoratorOptions, WrappedFormUtils} from "antd/lib/form/Form";
import {validateIcanId} from "./validator";

type Options = GetFieldDecoratorOptions | ((currOptions: GetFieldDecoratorOptions) => GetFieldDecoratorOptions);

export function getIcanFieldDecorator(form: WrappedFormUtils, fieldName: string, options?: Options){

    let currOptions: GetFieldDecoratorOptions = {
        rules: [
            {
                validator: validateIcanId
            }
        ]
    };

    if (typeof options === 'function'){
        currOptions = options(currOptions);
    }
    else if (typeof options === 'object' && options !== null){
        currOptions = {
            ...currOptions,
            ...options
        }
    }

    return form.getFieldDecorator(fieldName, currOptions);
}